$(() => {
   class MyFilter {
       constructor() {
           const toggleButton = document.querySelector('.js-toggle-filter');

           if (!toggleButton) {
               return;
           }

           this.toggleButton = toggleButton;
           this.body = document.querySelector('.js-filter-body');
           this.isOpen = false;

           this.text = {
               open: toggleButton.getAttribute('data-text'),
               close: `Закрыть ${toggleButton.getAttribute('data-text').toLowerCase()}`
           }

           this.icons = {
               open: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.66671C7.05452 4.66671 4.66671 7.05452 4.66671 10C4.66671 12.9456 7.05452 15.3334 10 15.3334C12.9456 15.3334 15.3334 12.9456 15.3334 10C15.3334 7.05452 12.9456 4.66671 10 4.66671ZM3.33337 10C3.33337 6.31814 6.31814 3.33337 10 3.33337C13.6819 3.33337 16.6667 6.31814 16.6667 10C16.6667 13.6819 13.6819 16.6667 10 16.6667C6.31814 16.6667 3.33337 13.6819 3.33337 10Z" fill="currentColor"/>
                <path d="M19.5286 20.4714C19.7889 20.7317 20.211 20.7317 20.4714 20.4714C20.7317 20.211 20.7317 19.7889 20.4714 19.5286L19.5286 20.4714ZM13.5286 14.4714L19.5286 20.4714L20.4714 19.5286L14.4714 13.5286L13.5286 14.4714Z" fill="currentColor"/>
                </svg>`,
               close: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
           }

           this.init();
       }

       updButton() {
           this.toggleButton.innerHTML = '';
           if (this.isOpen) {
               this.toggleButton.classList.add('js-toggle-filter--active');
               this.toggleButton.insertAdjacentHTML('afterBegin', this.text.close);
               this.toggleButton.insertAdjacentHTML('afterBegin', this.icons.close);
           } else {
               this.toggleButton.classList.remove('js-toggle-filter--active');
               this.toggleButton.insertAdjacentHTML('afterBegin', this.text.open);
               this.toggleButton.insertAdjacentHTML('afterBegin', this.icons.open);
           }
       }

       addHandlers() {
           this.toggleButton.addEventListener('click', () => {
               if (this.isOpen) {
                   $(this.body).slideUp({
                       queue: false
                   });
                   this.isOpen = false;
               } else {
                   $(this.body).slideDown({
                       queue: false
                   });
                   this.isOpen = true;
               }
               this.updButton();
           });
       }

       init() {
           this.updButton();
           this.addHandlers();
       }
   }

   if (typeof window.customClasses === 'object') {
       window.customClasses.MyFilter = MyFilter;
   } else {
       window.customClasses = {};
       window.customClasses.MyFilter = MyFilter;
   }

});
